/*
 *
 * Communications actions
 *
 */

import {
  FLUSH_STATE_COMMUNICATIONS,
  // load items list
  LOAD_COMMUNICATIONS,
  LOAD_COMMUNICATIONS_SUCCESS,
  LOAD_COMMUNICATIONS_ERROR,
} from './constants';

/**
 * Clearing the state for Communications
 */
export function flushStateCommunications() {
  return {
    type: FLUSH_STATE_COMMUNICATIONS,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Communications, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_COMMUNICATIONS
 */
export function loadCommunications(params, childId, firstRender = false) {
  return {
    type: LOAD_COMMUNICATIONS,
    params,
    childId,
    firstRender,
  };
}

/**
 * Dispatched when the loadCommunications are loaded by the request saga
 *
 * @param  {array} variables true for Communications
 *
 * @return {array} An action object with a type of LOAD_COMMUNICATIONS_SUCCESS passing the variables
 */
export function loadCommunicationsSuccess(allData, itemsList, params) {
  return {
    type: LOAD_COMMUNICATIONS_SUCCESS,
    allData,
    itemsList,
    params,
  };
}

/**
 * Dispatched when loading the loadCommunications fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_COMMUNICATIONS_ERROR passing the error
 */
export function loadCommunicationsError(error) {
  return {
    type: LOAD_COMMUNICATIONS_ERROR,
    error,
  };
}
